module.exports = __webpack_public_path__ + "static/media/play_btn.6ee76984.svg";